import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Divider } from "antd";

import { ChatbotAction } from "../../store/actions";

import ChatInput from "./chat-input";

const formatDividerDate = (date) => {
  const now = moment();
  const givenDate = moment(date);

  if (now.isSame(givenDate, "day")) {
    return "Today";
  } else if (now.subtract(1, "day").isSame(givenDate, "day")) {
    return "Yesterday";
  } else {
    return givenDate.format("MMMM Do YYYY");
  }
};

export default function ChatContainer({ currentChat, socket }) {
  const dispatch = useDispatch();
  const scrollRef = useRef();

  const profileData = useSelector((state) => state.profile?.user);

  const [messages, setMessages] = useState([]);
  const [arrivalMessage, setArrivalMessage] = useState(null);

  let lastMessageDate = null;

  useEffect(() => {
    const payload = {
      from: profileData?.id,
      to: currentChat?.userId,
    };
    dispatch(
      ChatbotAction.getMessages(payload, (res) => {
        setMessages(res.data);
        getUnreadMessages();
      })
    );
  }, [currentChat]);

  useEffect(() => {
    if (socket.current) {
      socket.current.on("msg-receive", (msg) => {
        setArrivalMessage({
          fromSelf: false,
          message: msg,
          receiverId: profileData?.id,
          senderId: currentChat?.userId,
        });
      });
    }
  }, []);

  useEffect(() => {
    arrivalMessage && setMessages((prev) => [...prev, arrivalMessage]);
  }, [arrivalMessage]);

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const getUnreadMessages = () => {
    dispatch(
      ChatbotAction.getUnreadMessages({
        from: profileData?.id,
      })
    );
  };

  const handleSendMsg = async (msg) => {
    socket.current.emit("send-msg", {
      to: currentChat.userId,
      from: profileData?.id,
      msg,
    });
    const payload = {
      from: profileData?.id,
      to: currentChat.userId,
      message: msg,
    };
    dispatch(ChatbotAction.addMessage(payload));

    const msgs = [...messages];
    msgs.push({
      fromSelf: true,
      message: msg,
      senderId: profileData?.id,
      receiverId: currentChat?.userId,
      date: new Date(),
    });
    setMessages(msgs);
  };

  return (
    <div className="chatbot-chat-container">
      <div className="p-3 text-[1em] font-bold border-b borer-b-gray-200">
        Chat Here
      </div>
      <div className="chatbot-chat-messages">
        {messages?.map((message, index) => {
          if (
            (message.senderId === currentChat?.userId &&
              message.receiverId === profileData?.id) ||
            (message.senderId === profileData?.id &&
              message.receiverId === currentChat?.userId)
          ) {
            const messageDate = moment(message?.date).startOf("day");
            let showDivider = false;

            if (
              !lastMessageDate ||
              !lastMessageDate.isSame(messageDate, "day")
            ) {
              showDivider = true;
              lastMessageDate = messageDate;
            }

            return (
              <div ref={scrollRef} key={index} className="flex flex-col">
                {showDivider && (
                  <Divider>
                    <div className="text-gray-500 text-[0.75em]">
                      {formatDividerDate(message?.date)}
                    </div>
                  </Divider>
                )}
                <div
                  className={`${
                    message.fromSelf
                      ? "chatbot-outgoing-chat"
                      : "chatbot-incoming-chat"
                  }`}
                >
                  {message?.message.split("\n").map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                  {/* {message?.date} */}
                  <div className="text-[0.625em] font-medium text-end">
                    {moment(message?.date).format("h:mm A")}
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
      <ChatInput handleSendMsg={handleSendMsg} />
    </div>
  );
}
